import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["icon"]

  toggle() {
    setTimeout(() => {
      this.iconTarget.classList.toggle("rotate-90", this.element.open)
    }, 0)
  }
}
